import "./extend/object.js";


let togglePanel = function(param) {

   let panel = this;

   let tgp = {
      create: function(param) {
         let defaults = {
            toggleButton: null,
            onOpening: async function(element) {  },
            onClosing: null
         };
         this.set = Object.extend(true, defaults, param);

         if (this.set.toggleButton === null) throw Error("TogglePanel: Kein Button definiert.");

         if (!panel.classList.contains('toggle-panel')) {
            panel.classList.add('toggle-panel');
            panel.setData('toggle-panel', this);

            this.set.toggleButton.addEventListener("click", (event) => {
               this.toggle();
            });
         }

      },

      open: function() {
         (this.set.onOpening || async function() {})(panel).then(() => {
            panel.style.maxHeight = panel.scrollHeight + "px";
         });
      },

      close: function() {
         (this.set.onClosing || async function() {})(panel).then(() => {
            panel.style.maxHeight = null;
         });
      },


      toggle: function() {
         this.set.toggleButton.classList.toggle("opened");
         if (panel.style.maxHeight) this.close();
         else                       this.open();
      }


   };

   if (typeof param === 'object') {
      tgp.create(param);
   }

   return tgp;

};



if (!HTMLElement.togglePanel) {
   HTMLElement.prototype.togglePanel = togglePanel;
}

NodeList.prototype.togglePanel = function() {
   for (let node of this) node.togglePanel(...arguments);
};
